import _ from "lodash";

const camelCaseKeys = (obj) => {
  if (!_.isObject(obj)) {
    return obj;
  } else if (_.isArray(obj)) {
    return obj.map((v) => camelCaseKeys(v));
  }
  return _.reduce(obj, (newObject, v, k) => {
    newObject[_.camelCase(k)] = camelCaseKeys(v)
    return newObject;
  }, {});
};

const kebabCaseKeys = (obj) => {
  if (!_.isObject(obj)) {
    return obj;
  } else if (_.isArray(obj)) {
    return obj.map((v) => kebabCaseKeys(v));
  }
  return _.reduce(obj, (newObject, v, k) => {
    newObject[_.kebabCase(k)] = kebabCaseKeys(v)
    return newObject;
  }, {});
}

const selectiveMerge = (obj1, obj2) => {
  return Object.keys(obj1).reduce(
    (obj, key) => ({ ...obj, [key]: obj2[key] || obj1[key] }),
    {}
  );
}

const numberizeValues = (obj) => {
  return _.mapValues(obj, (value) => {
    if (isNaN(value)) return value

    return (+value);
  });
}

export {
  camelCaseKeys,
  kebabCaseKeys,
  numberizeValues,
  selectiveMerge
};
